import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

// Axios-Instanz mit Auth-Header
const api = axios.create({
  baseURL: API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const brandingApi = {
  // Branding-Einstellungen laden (mit Auth)
  get: async () => {
    const response = await api.get('/branding');
    return response.data;
  },

  // Öffentliche Branding-Einstellungen laden (ohne Auth)
  getPublic: async () => {
    const response = await axios.get(`${API_URL}/branding/public`);
    return response.data;
  },

  // Branding-Einstellungen speichern
  update: async (data) => {
    const response = await api.put('/branding', data);
    return response.data;
  },

  // Logo hochladen
  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post('/branding/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Logo entfernen
  deleteLogo: async () => {
    const response = await api.delete('/branding/logo');
    return response.data;
  },

  // Auf Standardwerte zurücksetzen
  reset: async () => {
    const response = await api.post('/branding/reset');
    return response.data;
  }
};

// Named exports für einfacheren Import
export const getBranding = brandingApi.get;
export const updateBranding = brandingApi.update;
